import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Form,
  Grid,
  Button,
} from 'semantic-ui-react';

import ConnectButton from '../../ConnectButton';

import './scss/configurationPanel.scss';

class ConfigurationPanel extends React.Component {
  constructor(props) {
    super(props);

    const { settings } = this.props;

    this.state = {
      account: settings.account,
      agency: settings.agency,
      loading: false,
      tzId: settings.tzId,
    };
  }

  getSelectOptions = (settings, tz = false ) => (
    settings.map((setting, index) => ({
      key: index,
      text: tz ? setting.DisplayName : setting.QbFullname,
      value: tz ? setting.Id : setting.QbId,
    })));

  unshiftSelectOption = () => ({
    key: '0',
    text: 'Select one...',
    value: '',
  });

  handleOnSaveSettings = () => {
    const { call, onClose } = this.props;

    this.setState({ loading: true });

    call('Set', () => onClose(), this.state);
  }

  handleSelectionChanged = (value, property) => {
    const updatedState = this.state;

    updatedState[property] = value;

    this.setState(updatedState);
  }

  render() {
    const { lastFileOffset, onClose, settings } = this.props;
    const {
      account,
      agency,
      loading,
      tzId,
    } = this.state;
    const { accounts, agencies, tzs } = settings;

    const accountOptions = this.getSelectOptions(accounts);
    const agencyOptions = this.getSelectOptions(agencies);
    const tzOptions = this.getSelectOptions(tzs, true);

    const selectedTzOffset = tzs.find(tz => tz.Id === tzId).Offset;
    const tzError = lastFileOffset !== null && selectedTzOffset !== lastFileOffset &&
      `Please select a timezone matching your QuickBooks file (${lastFileOffset}).`;

    const isChanged =
      account !== settings.account ||
      agency !== settings.agency ||
      tzId !== settings.tzId;
    const isSaveable = isChanged && !tzError;

    if (!account) {
      accountOptions.unshift(this.unshiftSelectOption());
    }

    if (!agency) {
      agencyOptions.unshift(this.unshiftSelectOption());
    }

    return (
      <Modal
        closeIcon
        closeOnRootNodeClick={ false }
        dimmer="blurring"
        onClose={ onClose }
        open
      >
        <Modal.Header>Integration Settings</Modal.Header>

        <Modal.Content>
          <Grid>
            <Grid.Column width={ 3 } />

            <Grid.Column width={ 10 }>
              <Form>
                <Form.Field>
                  <Form.Select
                    fluid
                    label="Default Account"
                    onChange={ (e, data) => this.handleSelectionChanged(data.value, 'account') }
                    options={ accountOptions }
                    placeholder="Default Account"
                    search
                    value={ account }
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Select
                    fluid
                    label="Tax Agency"
                    onChange={ (e, data) => this.handleSelectionChanged(data.value, 'agency') }
                    options={ agencyOptions }
                    placeholder="Tax Agency"
                    search
                    value={ agency }
                  />
                </Form.Field>

                <Form.Field>
                  <Form.Select
                    error={ tzError.length > 0 }
                    fluid
                    label="Time Zone"
                    onChange={ (e, data) => this.handleSelectionChanged(data.value, 'tzId') }
                    options={ tzOptions }
                    placeholder="Time Zone"
                    search
                    value={ tzId }
                  />

                  { tzError && <span className="tzError">{ tzError }</span> }
                </Form.Field>
              </Form>
            </Grid.Column>
          </Grid>
        </Modal.Content>

        <Modal.Actions>
          <ConnectButton
            label="Re-Download QB Web Connector File"
            style={ { float: 'left' } }
          />

          <Button
            disabled={ !isSaveable }
            loading={ loading }
            onClick={ this.handleOnSaveSettings }
            positive
          >Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

ConfigurationPanel.propTypes = {
  lastFileOffset: PropTypes.any.isRequired,
  settings: PropTypes.shape({
    account: PropTypes.any,
    accounts: PropTypes.arrayOf(PropTypes.shape({
      QbFullname: PropTypes.string,
      QbId: PropTypes.any,
    })),
    agency: PropTypes.any,
    agencies: PropTypes.arrayOf(PropTypes.shape({
      QbFullname: PropTypes.string,
      QbId: PropTypes.any,
    })),
    tzId: PropTypes.any,
    tzs: PropTypes.arrayOf(PropTypes.shape({
      DisplayName: PropTypes.string,
      Id: PropTypes.any,
    })),
  }).isRequired,

  // functions
  call: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfigurationPanel;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/components/ConfigurationPanel.js